import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { CookiebotRoutingModule } from './cookiebot-routing.module';
import { CookiebotComponent } from './cookiebot.component';


@NgModule({
  declarations: [
    CookiebotComponent
  ],
  imports: [
    CommonModule,
    CookiebotRoutingModule
  ]
})
export class CookiebotModule { }
